import React, { Component } from 'react';
import { Button, Input, Select, DatePicker, Icon, Cascader } from 'antd';
import SearchRetrieve from '../../common/SearchRetrieve.new.js';
import SelectProvince from '../../common/SelectProvince';
import API_URL from '../../../common/url';
import ConditionsConfirmed from './conditionsConfirmed.js';
import $ from '../../../common/AjaxRequest';
import dictCache from '../../../common/dictCache';
import { AcquireStatus, RequirementType, RequirementOrigin, MedicineType, Status, Default, Storage, includes } from './constants';
import moment from 'moment';

const genOptions = data => Object.keys(data).map(i => <Option key={i}>{ data[i] }</Option>);
const genMomentDate = date => date ? moment(date) : null;

const { Option } = Select;
const { RangePicker } = DatePicker;
const dateFormat = 'YYYY-MM-DD';

const AcquireStatusOption = genOptions(AcquireStatus);
const RequirementTypeOption = genOptions(RequirementType);
const RequirementOriginOption = genOptions(RequirementOrigin);
const MedicineTypeOption = genOptions(MedicineType);
const DefaultOption = genOptions(Default);
const StatusOption = genOptions(Status);
const MedicineTypeList = [
    {value: 'Research_drugs', label: '药物'},
    {
        value: 'Technology', 
        label: '技术类',
        children: [
            {
                value: 'Radiation_therapy', 
                label: '放射疗法（同位素 核药；照射）',
            },
            {
                value: 'Cell_therapy', 
                label: '细胞治疗: CART',
            },
            {
                value: 'Stem_cell_therapy', 
                label: '干细胞治疗',
            },
            {
                value: 'Organ_transplant', 
                label: '器官移植',
            },
            {
                value: 'Gene_therapy', 
                label: '基因治疗',
            },
            {
                value: 'Dialysis', 
                label: '透析',
            },
        ]
    },
    {value: 'Medical_instruments', label: '医疗器械'},
    {value: 'Vaccines', label: '疫苗'},
    {value: 'Diagnostic_reagent', label: '诊断试剂'},
    {value: 'Others', label: '其他'},
]

class Filter extends Component {
    state = {
        searchParams: {},
        areaList: [],
        diseaseList: [],
        businessList: [],
        expand: false,
        render: true,
    }

    componentDidMount() {
        this.loadAreaList();
        this.queryWithLevelByParams();
    }

    search = () => {
        const { searchParams } = this.state;
        this.props.search(searchParams);
    }

    export = () => {
        this.props.export();
    }

    reset = () => {
        this.setState({
            render: false,
            searchParams: {},
            areaList: [],
            diseaseList: [],
        }, () => {
            this.setState({ render: true });
            this.search();
        });
    }
    
    handleKeyPress = e => {
        if (e.charCode === 13) {
            this.search();
        }
    }

    handleChange = (value, key) => {
        const { searchParams } = this.state;
        
        switch (key) {
            case "status":
                searchParams[key] = value ? value.join(',') : '';
                this.setState({ searchParams });
                break;
            case "lineOfBusiness":
                searchParams[key] = value;
                searchParams.secondLineName = undefined;
                this.setState({ searchParams });
                break;
            case "investigationAreaId":
                searchParams[key] = value;
                searchParams.diseaseId = undefined;
                this.setState({ searchParams }, () => {
                    this.loadDiseaseList();
                });
                break;
            case "hospital":
            case "investigationSponsor":
            case "directorUser": {
                const { value: id, text: name } = value;
                searchParams[`${key}Id`] = id;
                searchParams[`${key}Name`] = name;
                this.setState({ searchParams });
                break;
            }
            case 'planOnDutyTime':
            case 'planStartupTime': {
                const [start, end] = value;
                searchParams[`${key}Start`] = start;
                searchParams[`${key}End`] = end;
                this.setState({ searchParams });
                break;
            }
            default:
                searchParams[key] = value;
                this.setState({ searchParams });
                break;
        }
    }

    loadAreaList = () => {
        dictCache.getDict('AREA_ALL', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.common.queryAllInvestigationArea,
                data: {},
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            this.setState({ areaList: res.data });
        });
    }

    loadDiseaseList = () => {
        const { searchParams: { investigationAreaId } } = this.state;
        if (!investigationAreaId) {
            this.setState({ diseaseList: [] });
        } else {
            dictCache.getDict(`DISEASE_AREA_${investigationAreaId}`, cb => {
                $.sendRequest({
                    method: 'POST',
                    url: API_URL.common.queryAllDisease,
                    data: { investigationAreaId },
                    dataType: 'json',
                    doneResult: res => cb(res),
                });
            }, res => {
                this.setState({  diseaseList: res.data });
            });
        }
    }

    queryWithLevelByParams = () => {
        dictCache.getDict('LINE_OF_BUSINESS', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.common.queryWithLevelByParams,
                data: { typeName: 'LINE_OF_BUSINESS' },
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            this.setState({ businessList: res.typeConfigureList || [] });
        });
    }

    saveProvince = (checkedArea) => {
        const { searchParams } = this.state;
        const areaParams = {};
        checkedArea.forEach(item => {
            areaParams[`params[${item.props.title}]`] = item.key;
        });
        const areaList = checkedArea.map(item => item.props.title);
        const hasCheckedArea = checkedArea.map(item => item.key);
        this.setState({
            searchParams: {
                ...searchParams,
                areaParams,
                hasCheckedArea,
                areaName: areaList.join(','),
            }
        });
    }

    toggleHeight = () => {
        this.setState((prevState) => ({
            expand: !prevState.expand,
        }));
    }

    canCreatPlandDmand = () => {
        const { canEditByInvStatus } = this.props;
        const options = {
            method: 'POST',
            url: API_URL.member.judgeCanAddRequirement,
            data: {},
            dataType: 'json',
            doneResult: res => {
                const { canAdd , investigation} = res
                if( canAdd ) {
                    canEditByInvStatus(() => this.props.update({}, 'add'))
                }else {
                    this.ConditionsConfirmed.show(investigation);
                }
            },
            errorResult: err => {
                console.log(err);
            }
        };
        $.sendRequest(options);
    }

    render() {
        const { allowCreate, canAdd: addable, canEditByInvStatus } = this.props;
        const { curRole, crcSourcePlatformUrl ,invId } = sessionStorage;
        const {
            searchParams,
            areaList,
            diseaseList,
            businessList,
            expand,
            render,
        } = this.state;
        const { status, lineOfBusiness, areaName, hasCheckedArea, planOnDutyTimeStart, planOnDutyTimeEnd, planStartupTimeStart, planStartupTimeEnd } = searchParams;
        const planOnDutyTime = [genMomentDate(planOnDutyTimeStart), genMomentDate(planOnDutyTimeEnd)];
        const planStartupTime = [genMomentDate(planStartupTimeStart), genMomentDate(planStartupTimeEnd)];

        const canAdd = includes(['PM', 'PA'], curRole) && !Storage.isTotal;
        const showCrcSourcePlatform = Storage.isTotal && includes(['BO', 'CRCC', 'CRCM', 'CSAL'], curRole);
        
        const secondLineSet = new Set();
        businessList.forEach(i => {
            if (lineOfBusiness == i.typeConfigureId) {
                (i.childList || []).forEach(j => secondLineSet.add(j.typeValue));
            }
        });

        const businessOption = businessList.map(i => <Option key={i.typeConfigureId} value={i.typeConfigureId}>{i.typeValue}</Option>);
        const secondLineOption = [...secondLineSet].map(i => <Option key={i}>{i}</Option>);
        const areaListOption = areaList.map(d => <Option key={d.investigationAreaId}>{d.investigationAreaName}</Option>);
        const diseaseListOption = diseaseList.map(d => <Option key={d.diseaseId} value={d.diseaseId}>{d.diseaseName}</Option>);

        return (
            <div style={{marginBottom: 16}}>
                <div className={`search-bar expand ${expand ? 'expanded' : ''}`}>
                    <div className="expand-box">
                        <a onClick={this.toggleHeight}>
                            {expand ? "收起" : "展开"}
                            <Icon className="expand-icon" type={expand ? "up" : "down"} />
                        </a>
                    </div>
                    <div className="search-item">
                        <label htmlFor="" className="ui-label">需求编号</label>
                        <Input
                            placeholder="请输入"
                            style={{ width: 120 }}
                            value={searchParams.requirementCode}
                            onChange={e => this.handleChange(e.target.value, 'requirementCode')}
                            onKeyPress={this.handleKeyPress}
                        />
                    </div>
                    {
                        Storage.isTotal &&
                        <div className="search-item">
                            <label htmlFor="" className="ui-label">项目编号</label>
                            <Input
                                placeholder="请输入"
                                style={{ width: 120 }}
                                value={searchParams.investigationCode}
                                onChange={e => this.handleChange(e.target.value, 'investigationCode')}
                                onKeyPress={this.handleKeyPress}
                            />
                        </div>
                    }
                    {
                        Storage.isTotal &&
                        <div className="search-item">
                            <label htmlFor="" className="ui-label">项目简称</label>
                            <Input
                                placeholder="请输入"
                                style={{ width: 140 }}
                                value={searchParams.investigationName}
                                onChange={e => this.handleChange(e.target.value, 'investigationName')}
                                onKeyPress={this.handleKeyPress}
                            />
                        </div>
                    }
                    {
                        !Storage.isConcrete &&
                        <div className="search-item">
                            <label htmlFor="" className="ui-label">区域/城市</label>
                            {
                                render &&
                                <SelectProvince areaName={areaName} saveProvince={this.saveProvince} hasCheckedArea={hasCheckedArea} />
                            }
                        </div>
                    }
                    <div className="search-item">
                        <label htmlFor="" className="ui-label">发起人</label>
                        <Input
                            placeholder="请输入"
                            style={{ width: 100 }}
                            value={searchParams.requireUser}
                            onChange={e => this.handleChange(e.target.value, 'requireUser')}
                            onKeyPress={this.handleKeyPress}
                        />
                    </div>
                    <div className="search-item">
                        <label htmlFor="" className="ui-label">项目获得状态</label>
                        <Select
                            allowClear={true}
                            style={{ width: 120 }}
                            placeholder="请选择"
                            value={searchParams.investigationAcquisitionStatus}
                            onChange={value => this.handleChange(value, 'investigationAcquisitionStatus')}
                        >
                            { AcquireStatusOption }
                        </Select>
                    </div>
                    <div className="search-item">
                        <label htmlFor="" className="ui-label">需求类型</label>
                        <Select
                            allowClear={true}
                            style={{ width: 100 }}
                            placeholder="请选择"
                            value={searchParams.requirementInfoType}
                            onChange={value => this.handleChange(value, 'requirementInfoType')}
                        >
                            { RequirementTypeOption }
                        </Select>
                    </div>
                    <div className="search-item">
                        <label htmlFor="" className="ui-label">需求来源</label>
                        <Select
                            allowClear={true}
                            style={{ width: 100 }}
                            placeholder="请选择"
                            value={searchParams.requirementOrigin}
                            onChange={value => this.handleChange(value, 'requirementOrigin')}
                        >
                            { RequirementOriginOption }
                        </Select>
                    </div>
                    <div className="search-item">
                        <label htmlFor="" className="ui-label">启动前后是否要求同一人</label>
                        <Select
                            allowClear={true}
                            style={{ width: 80 }}
                            placeholder="请选择"
                            value={searchParams.afterBeforeStartupSameMember}
                            onChange={value => this.handleChange(value, 'afterBeforeStartupSameMember')}
                        >
                            { DefaultOption }
                        </Select>
                    </div>
                    {
                        Storage.isTotal &&
                        <div className="search-item">
                            <label htmlFor="" className="ui-label">项目领域</label>
                            <Select
                                allowClear={true}
                                style={{ width: 100 }}
                                placeholder="请选择"
                                value={searchParams.investigationAreaId}
                                onChange={value => this.handleChange(value, 'investigationAreaId')}
                            >
                                {areaListOption}
                            </Select>
                        </div>
                    }
                    {
                        Storage.isTotal &&
                        <div className="search-item">
                            <label htmlFor="" className="ui-label">疾病</label>
                            <Select
                                allowClear={true}
                                style={{ width: 120 }}
                                placeholder="请选择"
                                value={searchParams.diseaseId}
                                disabled={!searchParams.investigationAreaId}
                                onChange={value => this.handleChange(value, 'diseaseId')}
                            >
                                {diseaseListOption}
                            </Select>
                        </div>
                    }
                    {
                        Storage.isTotal &&
                        <div className="search-item">
                            <label htmlFor="" className="ui-label">研究产品类型</label>
                            <Cascader
                                allowClear={true}
                                style={{ width: 150 }}
                                placeholder="请选择"
                                options={MedicineTypeList}
                                value={searchParams.investigationMedicineType}
                                onChange={value => this.handleChange(value, 'investigationMedicineType')}
                            />
                        </div>
                    }
                    {
                        Storage.isTotal &&
                        <div className="search-item">
                            <label htmlFor="" className="ui-label">申办方</label>
                            <SearchRetrieve
                                keyword='customerCompanyName'
                                style={{ width: 162 }}
                                placeholder="输入名称检索"
                                value={searchParams.investigationSponsorName}
                                params={{ limit: 20, natureName: '申办方' }}
                                url={API_URL.investigation.queryCustomerCompanyByName}
                                config={{ id: 'customerCompanyId', name: 'customerCompanyName' }}
                                onChange={value => this.handleChange(value, 'investigationSponsor')}
                            />
                        </div>
                    }
                    {
                        !Storage.isConcrete &&
                        <div className="search-item">
                            <label htmlFor="" className="ui-label">中心编号</label>
                            <Input
                                placeholder="请输入"
                                style={{ width: 100 }}
                                value={searchParams.investigationSiteCode}
                                onChange={e => this.handleChange(e.target.value, 'investigationSiteCode')}
                                onKeyPress={this.handleKeyPress}
                            />
                        </div>
                    }
                    {
                        !Storage.isConcrete &&
                        <div className="search-item">
                            <label className="ui-label">中心名称</label>
                            <SearchRetrieve
                                keyword='keyword'
                                style={{ width: 180 }}
                                params={{ invId: 0, needSite: 'TRUE' }}
                                placeholder="输入中心/编号检索"
                                url={API_URL.manhour.queryManHourHospital}
                                value={searchParams.hospitalName}
                                config={{ id: 'hospitalId', name: 'hospitalName' }}
                                onChange={(option) => this.handleChange(option, 'hospital')}
                            />
                        </div>
                    }
                    <div className="search-item">
                        <label htmlFor="" className="ui-label">被分配人员</label>
                        <Input
                            placeholder="请输入"
                            style={{ width: 100 }}
                            value={searchParams.assignedUser}
                            onChange={e => this.handleChange(e.target.value, 'assignedUser')}
                            onKeyPress={this.handleKeyPress}
                        />
                    </div>
                    <div className="search-item">
                        <label htmlFor="" className="ui-label">处理人</label>
                        <Input
                            placeholder="请输入"
                            style={{ width: 100 }}
                            value={searchParams.assignUser}
                            onChange={e => this.handleChange(e.target.value, 'assignUser')}
                            onKeyPress={this.handleKeyPress}
                        />
                    </div>
                    <div className="search-item">
                        <label htmlFor="" className="ui-label">状态</label>
                        <Select
                            mode="multiple"
                            allowClear={true}
                            style={{ width: 140 }}
                            placeholder="请选择"
                            value={status ? status.split(',') : []}
                            onChange={value => this.handleChange(value, 'status')}
                        >
                            {StatusOption}
                        </Select>
                    </div>
                    <div className="search-item">
                        <label htmlFor="" className="ui-label">是否满足处理速度</label>
                        <Select
                            allowClear={true}
                            style={{ width: 80 }}
                            placeholder="请选择"
                            value={searchParams.satisfiedDealSpeed}
                            onChange={value => this.handleChange(value, 'satisfiedDealSpeed')}
                        >
                            {DefaultOption}
                        </Select>
                    </div>
                    <div className="search-item">
                        <label htmlFor="" className="ui-label">人员到位后是否有效利用</label>
                        <Select
                            allowClear={true}
                            style={{ width: 80 }}
                            placeholder="请选择"
                            value={searchParams.effectiveUse}
                            onChange={value => this.handleChange(value, 'effectiveUse')}
                        >
                            {DefaultOption}
                        </Select>
                    </div>
                    <div className="search-item">
                        <label htmlFor="" className="ui-label">业务线</label>
                        <Select
                            allowClear={true}
                            placeholder="请选择"
                            style={{width: 120}}
                            value={lineOfBusiness}
                            onChange={value => this.handleChange(value, 'lineOfBusiness')}
                        >
                            {businessOption}
                        </Select>
                    </div>
                    <div className="search-item">
                        <label htmlFor="" className="ui-label">执行业务线二级分类</label>
                        <Select
                            allowClear={true}
                            placeholder="请选择"
                            style={{width: 120}}
                            disabled={!lineOfBusiness}
                            value={searchParams.secondLineName}
                            onChange={value => this.handleChange(value, 'secondLineName')}
                        >
                            {secondLineOption}
                        </Select>
                    </div>
                    <div className="search-item">
                        <div className="ui-label">预计上岗时间</div>
                        <RangePicker
                            placeholder={["开始日期", "结束日期"]}
                            style={{width: 200}}
                            format={dateFormat}
                            value={planOnDutyTime}
                            onChange={(dates, dateStrings) => this.handleChange(dateStrings, 'planOnDutyTime')}
                        />
                    </div>
                    <div className="search-item">
                        <div className="ui-label">预计/实际启动时间</div>
                        <RangePicker
                            placeholder={["开始日期", "结束日期"]}
                            style={{width: 200}}
                            format={dateFormat}
                            value={planStartupTime}
                            onChange={(dates, dateStrings) => this.handleChange(dateStrings, 'planStartupTime')}
                        />
                    </div>
                    <div className="search-item">
                        <label htmlFor="" className="ui-label">医院主管</label>
                        <SearchRetrieve
                            keyword='keyword'
                            style={{ width: 142 }}
                            placeholder="输入姓名/工号检索"
                            value={searchParams.directorUserName}
                            params={{ limit: 20 }}
                            url={API_URL.team.userlist}
                            config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }}
                            onChange={value => this.handleChange(value, 'directorUser')}
                        />
                    </div>
                </div>
                <div className="search-bar flex-end">
                    <div className="search-item">
                        <Button type="primary" onClick={this.search}>搜索</Button>
                        <Button type="primary" onClick={this.reset}>重置</Button>
                        <Button type="primary" onClick={this.export}>导出</Button>
                        {
                            !Storage.isTotal &&
                            <Button className="btn-green" onClick={() => this.props.showRequireRemark(canAdd)}>项目需求描述</Button>
                        }
                        {
                            canAdd &&
                            (
                                allowCreate && addable ?
                                    <Button type="primary" onClick={this.canCreatPlandDmand}>新建计划需求</Button>
                                :
                                    <Button type="primary" disabled={true}>新建计划需求</Button>
                            )
                        }
                        {
                            showCrcSourcePlatform &&
                            <Button className="btn-green" onClick={() => window.open(atob(crcSourcePlatformUrl))}>CRC资源平台</Button>
                        }
                        {
                            !invId &&
                            <Button className="btn-green" onClick={() => window.open('https://wxbi.wuxiapptec.com/#/home/report/48')} style={{backgroundColor:'#ffcc00',border:'0'}}>CRC资源分析</Button>
                        }
                    </div>
                    <ConditionsConfirmed 
                        ref={el => this.ConditionsConfirmed= el } 
                        canEditByInvStatus={canEditByInvStatus} 
                        update={this.props.update}
                        businessList={businessList}
                    />
                </div>
            </div>
        );
    }
}

export default Filter;



// WEBPACK FOOTER //
// ./src/components/user/require/Filter.js